/**
 *
 * Created by vsuthar on 2018-11-30 File Autorization
 * Project: App Portal ©PaloAlto Networks
 */

import React, { Component } from 'react'
import { Tooltip } from '@pan/cloud-base'
import { store } from './App'
import { hasRole } from '../utils'

/**
 *
 * @param WrappedComponent
 * @param allowedRoles: Ex = ['Trap','Magnifier'] or ['Account Super User'] or ['Instance Admin']
 * @param rules: ['disabled','hide']
 * @param ReplaceComponentWith
 * @returns {{new(*=): WithAuthorization, new(props: Readonly<P>): WithAuthorization, new(props: P, context?: any): WithAuthorization, prototype: WithAuthorization}}
 * @constructor
 */
const Authorization = (WrappedComponent, allowedRoles, rules, ReplaceComponentWith) => {

  /**
   * return Modified component with apply roles logic
   */
  return class WithAuthorization extends Component {
    // constructor(props) {
    //   super(props)
    // }

    /**
     *
     * get logged in users role from redux store
     * @returns {{}}
     */

    getRoles() {
      const _store = store.getState()
      return _store.roles ? _store.roles : {}
    }


    replaceCmp() {
      return <ReplaceComponentWith />
    }

    /**
     *
     * We apply rules first on component. @rules is present then we check roles on order of disabled, hide ...etc
     * @returns {*}
     */
    applyRulesBasedOnRoles() {
      const isAllowed = this.checkIfPermitted()
      /**
       * Component needs to have disabled property in order to disabled component
       * Most of actionable component will have disabled property
       */
      if (!isAllowed && rules.indexOf('disabled') > -1) {
        // if (ReplaceComponentWith) {
        //   return this.replaceCmp()
        // }

        return <Tooltip getPopupContainer={el => el.parentNode} title={<span>You don’t have correct permission</span>}>
          <WrappedComponent {...this.props} disabled={true} />
        </Tooltip>
      }
      else if (!isAllowed && rules.indexOf('hide') > -1) {
        // if (ReplaceComponentWith) {
        //   return this.replaceCmp()
        // }
        return null
      }
      else {
        return <WrappedComponent {...this.props} />
      }
    }

    /**
     * Check permission when user passed using @allowedRoles. Get logged in users role and check against
     * logged in user permission
     *
     * @returns {boolean}
     */
    checkIfPermitted() {
      const _roles = this.getRoles()
      if (_roles) {
        if (allowedRoles && allowedRoles.length) {
          return hasRole(allowedRoles, _roles)
        }
        return false
      }
      else {
        return false
      }
    }

    render() {
      if (rules && rules.length) {
        return this.applyRulesBasedOnRoles()
      }
      if (this.checkIfPermitted()) {
        return <WrappedComponent {...this.props} />
      }
      else if (ReplaceComponentWith) { // if ReplaceComponentWith present then return with that component
        return <ReplaceComponentWith {...this.props} /> // if replace component is passed then we need to render replace component
      }
      else {
        return null // or <NoPage>No Access you have</>
      }
    }
  }
}

export default Authorization

